import React from 'react';
import './PaiementOk.scss';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Trans, useTranslation } from 'react-i18next';

const PaiementOk = ({
    goToSeance,
    onClose,
}) => {
    const { t } = useTranslation();
    return (
        <div>
            <DialogContent>
                <DialogContentText>
                    <Trans i18nKey="votre-acces-a-la-salle-est-valide-less-than-greater-than-bonne-seance">
                        Votre accès à la salle est validé,<br /> bonne séance !
                    </Trans>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t('fermer')}
                </Button>
                <Button type="submit" color="primary" onClick={goToSeance} >
                    {t('acceder-a-la-salle')}
                </Button>
            </DialogActions>
        </div>
    );
};

export default PaiementOk;
